export enum TabType {
	MIX,
	PLAYLIST,
	STATS,
}
